var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',_vm._g(_vm._b({staticStyle:{"width":"100%"},attrs:{"options":_vm.areaSource,"value":_vm.value,"filterable":"","collapse-tags":_vm.collapse}},'el-cascader',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e599082","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectArea.vue
// module id = null
// module chunks = 